export default "__VITE_ASSET__BHHIi6Lf__"